import { z } from 'zod';
import { createTeacherSchema, personNameSchema } from './accounts.js';
import { schoolCodeSchema } from './auth.js';
/**
 * The schools page: every school on the server, for a platform operator
 * (an admin named in `platform_operators`, migration 0010).
 */
const districtSchema = z.string().trim().max(80, 'Keep the district under 80 characters.');
export const createSchoolSchema = z.object({
    name: personNameSchema,
    code: schoolCodeSchema,
    /** A board code (AP_SSC) or id. */
    board: z.string().trim().min(1, 'Choose a board.'),
    district: districtSchema.optional(),
    admin: createTeacherSchema,
});
/** Name and district only: the code is on every student's sign-in slip. */
export const updateSchoolSchema = z.object({
    name: personNameSchema.optional(),
    district: districtSchema.nullable().optional(),
});
export const addSchoolAdminSchema = createTeacherSchema;
//# sourceMappingURL=platform.js.map